import { Motor, Battery, Propeller } from '../types';

export const defaultMotors: Motor[] = [
  {
    id: '1',
    brand: 'T-Motor',
    model: 'MN3110-470',
    kv: 470,
    maxPower: 466,
    weight: 80,
    diameter: 37.7,
    height: 28.5,
    recommendedProp: '15x5, 13x6.5',
    maxThrust: 1200,
    maxCurrent: 21.0,
    price: 420,
    notes: '高效中推力电机'
  },
  {
    id: '2',
    brand: 'T-Motor',
    model: 'MN3110-700',
    kv: 700,
    maxPower: 466,
    weight: 80,
    diameter: 37.7,
    height: 28.5,
    recommendedProp: '12x6, 11x7',
    maxThrust: 1150,
    maxCurrent: 21.0,
    price: 420,
    notes: '高转速版本'
  },
  {
    id: '3',
    brand: 'T-Motor',
    model: 'MN3508-380',
    kv: 380,
    maxPower: 310,
    weight: 82,
    diameter: 41.8,
    height: 26.5,
    recommendedProp: '15x5, 14x4.8',
    maxThrust: 1800,
    maxCurrent: 14.0,
    price: 480,
    notes: '大推力电机'
  },
  {
    id: '4',
    brand: 'T-Motor',
    model: 'MN3508-700',
    kv: 700,
    maxPower: 310,
    weight: 82,
    diameter: 41.8,
    height: 26.5,
    recommendedProp: '12x6, 11x7',
    maxThrust: 1650,
    maxCurrent: 14.0,
    price: 480,
    notes: '平衡型电机'
  },
  {
    id: '5',
    brand: 'Sunnysky',
    model: 'X4108S-380',
    kv: 380,
    maxPower: 420,
    weight: 113,
    diameter: 46,
    height: 25.5,
    recommendedProp: '15x5, 13x6.5',
    maxThrust: 2000,
    maxCurrent: 15.5,
    price: 280,
    notes: '性价比电机'
  },
  {
    id: '6',
    brand: 'Sunnysky',
    model: 'X4108S-480',
    kv: 480,
    maxPower: 420,
    weight: 113,
    diameter: 46,
    height: 25.5,
    recommendedProp: '13x6.5, 12x6',
    maxThrust: 1850,
    maxCurrent: 15.5,
    price: 280,
    notes: '中转速版本'
  },
  {
    id: '7',
    brand: 'Tarot',
    model: 'TL4006-680',
    kv: 680,
    maxPower: 400,
    weight: 52,
    diameter: 36,
    height: 25,
    recommendedProp: '11x7, 10x8',
    maxThrust: 1100,
    maxCurrent: 12.2,
    price: 180,
    notes: '轻量化设计'
  }
];

export const defaultBatteries: Battery[] = [
  {
    id: '1',
    brand: 'DJI',
    model: 'Mavic 3 Pro',
    cells: 4,
    capacity: 5000,
    voltage: 15.4,
    energy: 77,
    weight: 335,
    discharge: 5,
    size: '71×55×41',
    price: 1299,
    notes: '原装智能电池'
  },
  {
    id: '2',
    brand: 'Tattu',
    model: 'R-Line 4S 4500mAh',
    cells: 4,
    capacity: 4500,
    voltage: 14.8,
    energy: 66.6,
    weight: 295,
    discharge: 95,
    size: '138×42×36',
    price: 450,
    notes: '高倍率放电'
  },
  {
    id: '3',
    brand: 'GensAce',
    model: 'Bashing 4S 5200mAh',
    cells: 4,
    capacity: 5200,
    voltage: 14.8,
    energy: 77,
    weight: 348,
    discharge: 50,
    size: '139×43×37',
    price: 380,
    notes: '大容量版本'
  },
  {
    id: '4',
    brand: 'Tattu',
    model: 'UAV 4S 10000mAh',
    cells: 4,
    capacity: 10000,
    voltage: 14.8,
    energy: 148,
    weight: 940,
    discharge: 25,
    size: '169×65×39',
    price: 820,
    notes: '超大容量，适合长续航'
  },
  {
    id: '5',
    brand: 'GensAce',
    model: 'Soaring 4S 3300mAh',
    cells: 4,
    capacity: 3300,
    voltage: 14.8,
    energy: 48.8,
    weight: 285,
    discharge: 30,
    size: '105×35×34',
    price: 280,
    notes: '轻量化设计'
  }
];

export const defaultPropellers: Propeller[] = [
  {
    id: '1',
    brand: 'T-Motor',
    spec: '15x5.5',
    diameter: 15,
    pitch: 5.5,
    blades: 2,
    weight: 26.5,
    material: '碳纤维',
    thrustCoeff: 0.0165,
    powerCoeff: 0.0085,
    efficiency: 86,
    price: 68,
    notes: '大直径高效桨叶'
  },
  {
    id: '2',
    brand: 'T-Motor',
    spec: '12x6',
    diameter: 12,
    pitch: 6,
    blades: 2,
    weight: 19.2,
    material: '碳纤维',
    thrustCoeff: 0.0152,
    powerCoeff: 0.0088,
    efficiency: 84,
    price: 48,
    notes: '平衡型桨叶'
  },
  {
    id: '3',
    brand: 'T-Motor',
    spec: '11x7',
    diameter: 11,
    pitch: 7,
    blades: 2,
    weight: 16.8,
    material: '碳纤维',
    thrustCoeff: 0.0148,
    powerCoeff: 0.0092,
    efficiency: 82,
    price: 42,
    notes: '高螺距设计'
  },
  {
    id: '4',
    brand: 'Gemfan',
    spec: '12x5.5',
    diameter: 12,
    pitch: 5.5,
    blades: 3,
    weight: 24,
    material: '碳纤维尼龙',
    thrustCoeff: 0.0158,
    powerCoeff: 0.0095,
    efficiency: 81,
    price: 35,
    notes: '三叶设计，静音'
  },
  {
    id: '5',
    brand: 'Gemfan',
    spec: '10x5.5',
    diameter: 10,
    pitch: 5.5,
    blades: 2,
    weight: 14.2,
    material: '碳纤维',
    thrustCoeff: 0.0142,
    powerCoeff: 0.0098,
    efficiency: 79,
    price: 28,
    notes: '紧凑型桨叶'
  },
  {
    id: '6',
    brand: 'Gemfan',
    spec: '13x6.5',
    diameter: 13,
    pitch: 6.5,
    blades: 2,
    weight: 22.5,
    material: 'PC复合',
    thrustCoeff: 0.0162,
    powerCoeff: 0.0087,
    efficiency: 85,
    price: 32,
    notes: '大直径高效'
  },
  {
    id: '7',
    brand: 'HQProp',
    spec: '11x5',
    diameter: 11,
    pitch: 5,
    blades: 3,
    weight: 18.6,
    material: 'PC',
    thrustCoeff: 0.0145,
    powerCoeff: 0.0094,
    efficiency: 80,
    price: 25,
    notes: '经济型三叶桨'
  }
]; 